import React from 'react';

const Button = ({ text, onClick, type, buttonStyle, id  }) => {
    let style = 'btn large primary';

    if (buttonStyle === 'nav') {
        style = 'btn large primary';
    } else if (buttonStyle === 'secondary') {
        style = 'btn large secondary';
    } else if (buttonStyle === 'txt') {
        style = 'btn txt';
    }
    return (
        // eslint-disable-next-line
        <button id={id} className={style} type={`${type ? type : 'button'}`} onClick={onClick}>
            {text}
        </button>
    );
};

export default Button;
